import { PRIMARY_COLOR } from '../../constants'
import { LoadingOval } from './Spinner'

export const RefreshLoader = ({ text = 'Refreshing' }: { text?: string }) => {
  return (
    <div className="z-[99] fixed left-[calc(50%-73px)] flex bg-white border rounded-full px-4 py-2 shadow-2xl items-center gap-3 top-32">
      <p>{text}</p>
      <LoadingOval color={PRIMARY_COLOR} />
    </div>
  )
}
